module.exports = __webpack_public_path__ + "static/media/Renewal.9e96811f.svg";